import { create } from 'zustand';

/**
 * 모바일에서 상세가 목록을 덮고 있는가. 창 제목줄 ‹(`CreatorRelationsMobileBack`)가 본문 밖에
 * 서 있어서 상태를 store 로 나른다 — 퀘스트 창의 `mobileShowDetailByPanel` 과 같은 까닭이다.
 */
interface RelationMobileDetailState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useRelationMobileDetailStore = create<RelationMobileDetailState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
